import settings from '/@/core/settings';
import { axFetch } from '/@/store/session/actions';

export type AccessRequestType = 'rv' | 'advisor' | 'consultant' | 'other';
export type AccessRequestStatus = 'pending' | 'accepted' | 'rejected';

export interface AccessRequestPayload {
    appInstance: number;
    name: string;
    email: string;
    /** Already normalized to E.164 by the form -- see `createAccessRequestApi`. */
    phone: string;
    type: AccessRequestType;
    distributor?: string;
    referent?: string;
}

export interface AccessRequestCreated {
    status: AccessRequestStatus;
    /** Only present when the request was auto-accepted against Identity. */
    token: string | null;
    /** This email already has an account: sign in, do not create a password. */
    userExists: boolean;
}

export interface AccessRequestDetail {
    name: string;
    email: string;
    phone: string;
    type: AccessRequestType;
    status: AccessRequestStatus;
    /** See `AccessRequestCreated.userExists`. */
    userExists: boolean;
}

const requestsUrl = () => (settings as any).urls.accessRequests.requests as string;

export const createAccessRequestApi = async (payload: AccessRequestPayload): Promise<AccessRequestCreated> => {
    const apiUrl = new URL(requestsUrl(), window.location.origin);
    const res = await axFetch.post(apiUrl.toString(), payload);
    return res.data;
};

export const getAccessRequestApi = async (token: string): Promise<AccessRequestDetail> => {
    // The detail endpoint is the create URL plus the token, per the backend urlconf.
    const apiUrl = new URL(`${requestsUrl()}${token}/`, window.location.origin);
    const res = await axFetch.get(apiUrl.toString());
    return res.data;
};
